import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const firebaseConfig = { 
    apiKey: "AIzaSyDUrm58X5DizNapORmiaZlF67G07thBlHQ",
    authDomain: "feedback-60109.firebaseapp.com",
    databaseURL: "https://feedback-60109.firebaseio.com",
    projectId: "feedback-60109",
    storageBucket: "feedback-60109.appspot.com",
    messagingSenderId: "1018352021349",
    appId: "1:1018352021349:web:2e87912012f2b9c7a2bb8c",
    measurementId: "G-68MLJZ7711"
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();